import React, { useCallback, useState } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import {
  CHANGE_SIDE_LABELS,
  CLOSED_FILE_VIEW,
  TEMPLATE_SIDES,
} from '../../FormChangeHistory.constants';
import { TemplateSideLabelsPropType } from '../../FormChangeHistory.propTypes';
import TemplateFileModal from '../TemplateFileModal';
import TemplateFileSide from '../TemplateFileSide';

import { fileSidesStyles } from './TemplateFileVersions.styles';

/** Both sides' files; each opens from its change (`auditId`), and only facts show without one. */
const TemplateFileVersions = ({
  files,
  auditId = null,
  isPdf = false,
  sideLabels = CHANGE_SIDE_LABELS,
}) => {
  // The side stays set while the modal closes, so its body never re-renders for no side.
  const [viewedFile, setViewedFile] = useState(CLOSED_FILE_VIEW);

  const onOpenFile = useCallback(side => setViewedFile({ side, isOpen: true }), []);
  const onCloseFile = useCallback(
    () => setViewedFile(previous => ({ ...previous, isOpen: false })),
    [],
  );

  const isOpenable = !!auditId;

  return (
    <>
      <Box sx={fileSidesStyles}>
        {TEMPLATE_SIDES.map(side => (
          <TemplateFileSide
            copyChecksumLabel={sideLabels.copyChecksum[side]}
            facts={files[side] ?? null}
            isPdf={isPdf}
            key={side}
            side={side}
            title={sideLabels.title[side]}
            onOpen={isOpenable ? onOpenFile : null}
          />
        ))}
      </Box>
      {isOpenable && (
        <TemplateFileModal
          auditId={auditId}
          facts={files[viewedFile.side] ?? null}
          isOpen={viewedFile.isOpen}
          isPdf={isPdf}
          side={viewedFile.side}
          onClose={onCloseFile}
        />
      )}
    </>
  );
};

TemplateFileVersions.propTypes = {
  files: PropTypes.shape({ before: PropTypes.object, after: PropTypes.object }).isRequired,
  auditId: PropTypes.string,
  isPdf: PropTypes.bool,
  sideLabels: TemplateSideLabelsPropType,
};

export default TemplateFileVersions;
